import { StyleInputType } from '../../styles/inputType';

export const checkboxQuickStylesDefinitions = {
  checkboxBackgroundColor: StyleInputType.COLOR,
  checkboxColor: StyleInputType.COLOR,
} satisfies Record<string, StyleInputType>;
